import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import posthog from "posthog-js";


// Initialize PostHog
posthog.init("phc_23Fz0pEhUmH63zXpN04hoL7ROeRpi0ZGCPg9qQfZF0o", {
  api_host: "https://us.i.posthog.com",
  autocapture: true,
});

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

// For performance monitoring
reportWebVitals();
